import React, { useState } from "react";
import { Box, Paper, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Preview, Visual } from "pages/MaterialSpecs/components/PreviewSelector";
import { useMaterialSpecs } from "pages/MaterialSpecs/hooks";
import { Controls } from "pages/MaterialSpecs/components/AnnotationSection/Controls/Controls";
import { useAnnotationsHandler } from "pages/MaterialSpecs/hooks/useAnnotationsHandler";
import { ConfirmationDialog } from "components";

export const AnnotationSection = () => {
    const { t } = useTranslation();
    const { goBack, isVisualVisible } = useMaterialSpecs();
    const {
        isDrawingMode,
        annotationDrawingType,
        showAnnotations,
        isDirty,
        onZoomIn,
        onZoomOut,
        reset,
        onDrawSelectionHandler,
        onSetShowAnnotations,
    } = useAnnotationsHandler();

    const [showUnsavedWarning, setShowUnsavedWarning] = useState<boolean>(false);

    return (
        <Box component={Paper} height="100%" overflow="hidden" display="flex" flexDirection="column">
            <Controls
                onReturn={() => {
                    if (isDirty) {
                        setShowUnsavedWarning(true);

                        return;
                    }

                    goBack();
                }}
                onZoomIn={onZoomIn}
                onZoomOut={onZoomOut}
                onResetTransform={reset}
                onDrawSelectionHandler={onDrawSelectionHandler}
                onSetShowAnnotations={onSetShowAnnotations}
                annotationType={annotationDrawingType}
                isDrawingMode={isDrawingMode}
                showAnnotations={showAnnotations}
            />
            {isVisualVisible ? <Visual /> : <Preview />}

            <ConfirmationDialog
                headerLabel={t("confirmationDialog.label.warning")}
                isOpen={showUnsavedWarning}
                onClose={(isConfirmed) => {
                    if (isConfirmed) {
                        goBack();

                        return;
                    }

                    setShowUnsavedWarning(false);
                }}>
                <Typography variant={"body2"}>{t("campaign.warnings.unsavedChanges")}</Typography>
            </ConfirmationDialog>
        </Box>
    );
};
